/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingArchivedConfig } from '../../config/loading.config';
export interface ILoadingArchivedPluginMethods extends IPluginMethodMap {
  getLoadingArchivedSync(args?: any): any;
}

export class LoadingArchivedPlugin implements IAgentPlugin {
  readonly methods: ILoadingArchivedPluginMethods;

  constructor() {
    this.methods = {
      getLoadingArchivedSync: this.getLoadingArchivedSync.bind(this),
    };
  }

  getLoadingArchivedSync(args?: any) {
    return {
      loading: loadingArchivedConfig,
    };
  }
}
